module.exports = __webpack_public_path__ + "img/versionBanner1.5a368998.jpg";